import { createApp } from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import plugins from '@/plugins';
import validate from '@/plugins/validate';
import * as Sentry from '@sentry/vue';
import Clarity from '@microsoft/clarity';

import '@/assets';
import components from '@/components';

import { HasError, AlertError, AlertErrors, AlertSuccess } from 'vform/src/components/tailwind';

const app = createApp(App);

Sentry.init({
    app,
    environment: import.meta.env.VITE_APP_ENV,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [Sentry.browserTracingIntegration({ router }), Sentry.browserProfilingIntegration()],
    tracePropagationTargets: [import.meta.env.VITE_BASE_URL],
    tracesSampleRate: 1.0,
    profilesSampleRate: 1.0,
});

Clarity.init(import.meta.env.VITE_CLARITY_PROJECT_ID);

app.component(HasError.name, HasError);
app.component(AlertError.name, AlertError);
app.component(AlertErrors.name, AlertErrors);
app.component(AlertSuccess.name, AlertSuccess);

app.use(router);
app.use(store);
app.use(validate);

plugins(app);
components(app);

app.mount('#app');
